<app-price-annual-fee class="app-price-card"></app-price-annual-fee>
<app-price-degressivity-slice class="app-price-card"></app-price-degressivity-slice>
<app-price-public-degressivity-slice class="app-price-card"></app-price-public-degressivity-slice>
<app-price-default-price class="app-price-card"></app-price-default-price>
